import { render, staticRenderFns } from "./popRemark.vue?vue&type=template&id=33c40d66&scoped=true"
import script from "./popRemark.vue?vue&type=script&lang=js"
export * from "./popRemark.vue?vue&type=script&lang=js"
import style0 from "./popRemark.vue?vue&type=style&index=0&id=33c40d66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c40d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c40d66')) {
      api.createRecord('33c40d66', component.options)
    } else {
      api.reload('33c40d66', component.options)
    }
    module.hot.accept("./popRemark.vue?vue&type=template&id=33c40d66&scoped=true", function () {
      api.rerender('33c40d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/common/popRemark.vue"
export default component.exports